module.exports = __webpack_public_path__ + "img/team-2.bbd5909c.png";